/**
 * @graphql cc
 */
import gql from 'graphql-tag';

import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { isGraphQLError } from '@confluence/network';
import { isErrorMarkedAsHandled } from '@confluence/graphql/entry-points/isErrorMarkedAsHandled.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';

import type { useReverseTrialEligibleSignUpPropertiesQuery as useReverseTrialEligibleSignUpPropertiesQuery$data } from './__types__/useReverseTrialEligibleSignUpPropertiesQuery.ts';

type HookType = {
	skip: boolean;
};

export const useReverseTrialEligible = ({ skip }: HookType = { skip: false }) => {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	const skipQuery = skip || Boolean(process.env.REACT_SSR); // Query is not preloaded and can be skipped during SSR to avoid unnecessary requests

	const QUERY_DOC = gql`
		query useReverseTrialEligibleSignUpPropertiesQuery {
			signUpProperties {
				reverseTrial
			}
		}
	`;

	const { data, loading, error } = useQuery<useReverseTrialEligibleSignUpPropertiesQuery$data>(
		QUERY_DOC,
		{
			skip: skipQuery,
		},
	);

	if (isGraphQLError(error) && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	return {
		reverseTrialCohort: data?.signUpProperties?.reverseTrial,
		loading: skipQuery ? false : loading,
		error: skipQuery ? null : error,
	};
};
